// extracted by mini-css-extract-plugin
module.exports = {"Choice":"Choice__12jii","isSelected":"isSelected__1ji01","isDisabled":"isDisabled__1T6AD","Hotkey":"Hotkey__1lAww"};